import React from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'

export const UnblockLoanerInventoryItem = ({
  loanerInventoryItem,
  onUpdate,
}) => {
  const dispatch = useDispatch()
  let OnUnblockConfirm = function () {
    new rest.LoanerInventoryService(loanerInventoryItem.url)
      .unblock()
      .then((response) => {
        onUpdate()
        dispatch(showSuccessToast('Success', 'Loaner items  Unblocked.'))
      })
      .catch((errors) => {
        console.log(errors)
        dispatch(
          showErrorToast(
            'Error',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={OnUnblockConfirm}
        body="Are you sure you want to unblock this Loaner Inventory  item?"
        confirmText="Confirm unblock Loaner Inventory  Item"
        confirmBSStyle="danger"
        title="Unblock Loaner Inventory  Item"
      >
        <ReactBootstrap.Dropdown.Item
          disabled={!loanerInventoryItem.is_blocked}
          variant="dark"
          eventKey="1"
        >
          {components.ICONS.EDIT} Unblock
        </ReactBootstrap.Dropdown.Item>
      </components.Confirm>
    </>
  )
}
